import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  skeletonWrapper: {
  width: "auto"
  },
  rightContainer: {
    display: "grid",
    gap: "16px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: 0
    }
  },
  rightTopContainer: {
    display: "flex",
    gap: "8px",
    justifyContent: "space-between",
    alignItems: "center",
    width: "512px",
    borderRadius: "8px",
    border: "1px solid" + colors.lightGrey,
    padding: "16px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "auto",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
      flexDirection: "column",
      alignItems: "flex-start",
      margin: 0
    }
  },
  rightTopContainerWrapper:{
    display: "flex",
    gap: "16px",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%"
    }
  },
  iconWrapper: {
    border: "1px solid" + colors.lightGrey,
    borderRadius: "10px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "48px",
    width: "48px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    "& span:first-child": {
      display: "flex"
    },
  },
  containerDescription: {
    "& h1": {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "20px",
      color: colors.grey,
      margin: 0
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      color: colors.mediumGrey,
      margin: 0,
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        "& span": {
          width: "100% !important"
        }
      }
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%"
    }
  },
  button: {
    borderRadius: "8px",
    lineHeight: "20px",
    padding: "10px 16px",
    color: theme.buttons.default.color,
    backgroundColor: theme.buttons.default.backgroundColor,
    border: theme.buttons.default.border,
  },
  shortSk: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey
  }
}));

export default styles;
